import styled from 'styled-components';

export const ScrollWrapper = styled.div<{ offsetTop: number }>`
  scroll-margin: ${({ offsetTop }) => `${offsetTop + 15}px`};
  display: flex;
  justify-content: center;
  width: 100%;
`;
